import { RuleDecl } from "vue/types/options";
import { required, requiredIf, minLength, maxLength, integer, maxValue, minValue } from "vuelidate/lib/validators";
import { IRequest, IRequestFile, RequestFileTypes, RequestStatus } from "@/models";

export const validations: RuleDecl = {
    request: {
        key: { required },
        affiliate: { required },
        brand: { required },
        countries: { required, minArrayLength: minLength(1) },
        campaignName: { required, minLength: minLength(4), maxLength: maxLength(300) },
        campaignDescription: { required, minLength: minLength(4), maxLength: maxLength(3000) },
        typeOfCampaign: { required },
        typeOfAssets: { required },
        media: { required, minArrayLength: minLength(1) },
        numberOfAssets: { required, integer, minValue: minValue(1), maxValue: maxValue(9999) },
        decisionDeadline: { required: requiredIf(isDecisionDeadlineRequired) },
        decisionDescription: {
            requiredDescription: requiredIf(isDecisionDescriptionRequired),
            descriptionMinLength: minLength(4),
            descriptionMaxLength: maxLength(3000),
        },
        files: {
            atleastOneDefaultFile,
            onlyOneCoverFile: haveOneCoverFile,
        },
    },
};

export const validationMessages = {
    requiredDescription: "Description is required",
    descriptionMinLength: "Description must have at least {min} letters",
    descriptionMaxLength: "Description must have less than {max} letters",
    atleastOneDefaultFile: "A file is required",
    onlyOneCoverFile: "Provide ONE cover image",
};

function haveOneCoverFile(files: IRequestFile[]): boolean {
    if (!isFilesRequired) {
        return true;
    }

    const coverFiles: IRequestFile[] = files?.filter(f => f.fileType === RequestFileTypes.Cover);
    return coverFiles && coverFiles.length === 1;
}

function atleastOneDefaultFile(files: IRequestFile[]): boolean {
    if (!isFilesRequired) {
        return true;
    }

    return files?.some(f => f.fileType === RequestFileTypes.Default);
}

function isDecisionDeadlineRequired(value: IRequest): boolean {
    return !!value?.requestStatus?.step &&
        value.requestStatus.step > 0 &&
        value.requestStatus.name !== RequestStatus.submitted.toString() &&
        value.requestStatus.name !== RequestStatus.toModify.toString();
}

function isDecisionDescriptionRequired(value: IRequest): boolean {
    return value?.requestStatus.step > 1;
}

function isFilesRequired(value: IRequest): boolean {
    return value?.requestStatus.name !== RequestStatus.draft;
}
